import React, { useEffect, useState, useCallback } from "react";
import { CardItem } from "../../../common/Card/Card";
import { CardBody } from "../../../common/Card/CardBody";
import CardGroup from "../../../common/Card/CardGroup";
import CssLoader from '../../../components/cssloader/CssLoader';
import Pagination from "../../../common/Pagination";
import Advertising from "../../../common/Advertising";
import { apiGet } from "../../../services/Api";
import { VideoItem, VideosList } from "../../../helpers/interfaces/video";
import PageMeta from "../../../components/PageMeta";

export default function VideoListPage() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [videosList, setVideosList] = useState<CardItem[]>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const pageLimit = 20;
    const pageNeighbours = 5;

    const fetchVideosList = useCallback(async () => {
        setIsLoading(true);

        await apiGet<VideosList, any>('?op=listaVideo&pag=' + currentPage).then((
            videos: VideosList
        ) => {
            let list: CardItem[] = [];
            setTotalRecords(videos.totalCount ?? 0);

            videos.videos.forEach((video: VideoItem) => {
                list.push({
                    id: video.id,
                    title: video.name,
                    subtitle: <>{video.created_at} - <span className="author-name">CalcioA5Live</span></>,
                    content: null,
                    image: video.img,
                    link: '/video/' + video.id
                })
            });

            setVideosList(list);
        }).finally(() => {
            setIsLoading(false);
        })

    }, [currentPage]);

    useEffect(() => {
        fetchVideosList()
    }, [currentPage, fetchVideosList])

    let count = 0;
    let totalCount = 0;
    let cardItems: CardItem[] = []

    return (
        <React.Fragment>
            <PageMeta
                title="Video - Calcio a 5 Live"
                description=""
                image=""
                url={document.location.href}
                type=""
            />
            <div id="video-list">
                <h1>Video</h1>
                <hr />
                {videosList.map((card: CardItem, index: number) => {
                    count++;
                    totalCount++;
                    cardItems.push(card);

                    if (
                        count % 6 === 0 ||
                        totalCount === videosList.length
                    ) {
                        const videoCardGroup = [...cardItems];
                        cardItems = [];
                        count = 0;

                        return (
                            <div key={index}>
                                <CardGroup cards={videoCardGroup} columns={3} id={'video-' + index} cardBody={CardBody} />
                                {count % 6 === 0 && totalCount < videosList.length ? <>
                                    {count === 6 && <Advertising code="banner-cat4" as="div" class="test" />}
                                    {count === 12 && <Advertising code="banner-cat5" as="div" />}
                                    {count === 18 && <Advertising code="banner-cat6" as="div" />}
                                </> : <></>}
                            </div>
                        );
                    } else {
                        return <React.Fragment key={index}></React.Fragment>;
                    }
                })}
                <div className="py-3">
                    <Pagination
                        totalRecords={totalRecords}
                        pageLimit={pageLimit}
                        pageNeighbours={pageNeighbours}
                        currentPage={currentPage}
                        onPageChanged={setCurrentPage}
                    />
                </div>

                <CssLoader active={isLoading} text="Caricamento dell'elenco video in corso..." />
            </div>
        </React.Fragment>
    );
}
